import { http } from "@/services/http/client";
import { endpoints } from "@/services/api/endpoints";
import { getOrCreateDeviceId, type VoipTokenPayload } from "@/lib/device";

export async function registerVoipDeviceToken(payload: {
  token: string;
  sip_username?: string;
}) {
  const token = payload.token.trim();
  if (!token) return;

  const body: VoipTokenPayload & { token: string } = {
    token,
    fcm_token: token,
    device_id: getOrCreateDeviceId(),
    platform: "web",
    token_type: "FCM",
    sip_username: payload.sip_username,
  };

  await http.post(endpoints.voipDeviceTokens, body);
}

export async function unregisterVoipDeviceToken(token?: string | null) {
  const body: Record<string, string> = {
    device_id: getOrCreateDeviceId(),
  };
  if (token) {
    body.token = token;
    body.fcm_token = token;
  }
  try {
    await http.delete(endpoints.voipDeviceTokens, { data: body });
  } catch {
    // Best-effort cleanup on logout.
  }
}
